<template>
  <div>
    <el-autocomplete
      class="inline-input"
      v-model="internalValue"
      :fetch-suggestions="querySearch"
      placeholder="请选择线索来源"
      @input="onInput"
      style="width: 100%"
    ></el-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      internalValue: this.value,
      restaurants: [
        "葱哥抖音私信",
        "葱哥抖音电话",
        "葱哥抖音视频",
        "葱哥账号直播间",
        "律烁丁律",
        "律烁王律",
        "律烁徐律",
        "张宏涛律师",
        "樊律",
        "房老师",
        "爆哥抖音私信",
      ],
    };
  },
  created() {
    // 初始化本地存储
    const saved = localStorage.getItem("restaurants");
    if (saved) {
      this.restaurants = JSON.parse(saved);
    }

    // 初始化节流保存函数
    this.debouncedSave = this.debounce(this.tryAddRestaurant, 10000);
  },
  watch: {
    // 父组件更新值时，同步到内部
    value(newVal) {
      this.internalValue = newVal;
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
      this.debouncedSave(val);
    },
    querySearch(queryString, cb) {
      const results = queryString
        ? this.restaurants.filter(this.createFilter(queryString))
        : this.restaurants;

      // 转换成 { value: 'xxx' } 的形式
      cb(results.map((item) => ({ value: item })));
    },
    createFilter(queryString) {
      return (restaurant) =>
        restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    },
    tryAddRestaurant(val) {
      const input = val.trim();
      if (!input) return;

      if (!this.restaurants.includes(input)) {
        this.restaurants.push(input);
        localStorage.setItem("restaurants", JSON.stringify(this.restaurants));
        console.log("✅ 添加新线索来源到本地：", input);
      } else {
        console.log("ℹ️ 已存在，无需添加：", input);
      }
    },
    debounce(fn, delay) {
      let timer = null;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    },
  },
};
</script>

<style scoped lang="scss">
.inline-input {
  width: 100%;
}
</style>
